var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeLogActivity01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "See Log Activity") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.93,15.8l3.21-4.18,3.67,2.88L16,10.44"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 19.62,
    cy: 4.44,
    r: 3.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.17,3.28H6.37c-3.24,0-5.24,2.29-5.24,5.52v8.68c0,3.24,2,5.52,5.24,5.52h9.24c3.23,0,5.24-2.28,5.24-5.52V9.92"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeLogActivity01);
export default __webpack_public_path__ + "static/media/See_Log_Activity_01.231bef4253c2853453bb2fc15e43dbd1.svg";
export { ForwardRef as ReactComponent };